import React from "react";
import style from "../../styles/instructionview";
import colors from "../../styles/colors";
import InstructionHeader from "./InstructionHeader";
import InstructionAttribute from "./InstructionAttribute";

export default (props) => {
  const lblStyle = {
    marginRight: 5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color:
      props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
        ? props.whiteLabelSettings.primaryColor
        : colors.primary,
  };
  return (
    <div>
      <InstructionHeader {...props} />
      <div style={style.labelContainer}>
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Reps:"
          value={props.numRepetitions}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Sets:"
          value={props.numSets}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Duration:"
          value={props.duration}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Intensity:"
          value={props.intensity}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Frequency:"
          value={props.frequency}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Rest:"
          value={props.rest}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Hold:"
          value={props.hold}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Tempo:"
          value={props.tempo}
        />
        <InstructionAttribute
          lblStyle={lblStyle}
          label="Weight:"
          value={props.weight}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/InstructionDetails.js